import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {select, Store} from '@ngrx/store';
import {skip, take, takeUntil} from 'rxjs/operators';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {hasFeature} from '@shared/store/selectors/security.selector';
import {DashboardService} from '@core/services/dashboard.service';

@Component({
    standalone: false,
    selector: 'particle-forms-download',
  templateUrl: './forms-download.component.html',
  styleUrls: ['./forms-download.component.scss']
})
export class FormsDownloadComponent implements OnInit, OnDestroy {
  formId: string;
  ngUnsubscribe$ = new Subject<void>();
  private hasFeature$;
  constructor(private activatedRoute: ActivatedRoute,
              private dashboardService: DashboardService,
              private securityStore: Store<SecurityState>,
              private snackbarService: SnackBarService,
              private route: Router,
              private fuseSplashScreen: FuseSplashScreenService) { }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(params => {
      this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
      this.fuseSplashScreen.show();
      this.hasFeature$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(features => {
        if (features && features('ITCE')) {
          this.formId = params['formId'];
          this.downloadForm();
        } else {
          console.error('You do not have permission to access the tool.');
          this.fuseSplashScreen.hide();
          this.route.navigateByUrl('/promotion/itrce');
          // window.location.href='https://itp.orbitax.com/promotion/itrce';
        }
      });
    }, err => {
      console.error('Can not fetch formId' + err);
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private downloadForm() {
    this.fuseSplashScreen.show();
    if (this.formId == null || this.formId === '') {
      console.error('Form Id can not be null');
      this.fuseSplashScreen.hide();
      this.route.navigateByUrl('/home');
    }
    this.dashboardService.getFormFile(this.formId).pipe(take(1)).subscribe((response: any) => {
      const fileName = response.headers.get('fileName');
      const url = window.URL.createObjectURL(response.body);
      const a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_self');
      a.setAttribute('download', fileName);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.fuseSplashScreen.hide();
      this.route.navigateByUrl('/home');
    }, err => {
      this.fuseSplashScreen.hide();
      console.error('Something went wrong in downloading file.' + err);
      this.snackbarService.showError('Can\'t download at the moment. Please try again');
    });
  }
}
